import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-gitlab-issue',
  templateUrl: './gitlab-issue.component.html',
  styleUrls: ['./gitlab-issue.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class GitlabIssueComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
